/*
  Kiwi Ears · card quick-add (Rene 2026-09-04).

  ONE delegated handler for every .pk-padd button on the site, replacing seven
  byte-identical copies that each section used to bind to its own container.

  Why delegation rather than a shared init():
    · the card (snippets/pk-pair-card.liquid) ships the button but no handler,
      so the button only worked where a section happened to bind it. It was
      dead on the collection grid, the finder's filtered grid, ag-products,
      cr-work, ed-lineup, fys-quiz and tc-lineup — the highest-traffic grids on
      the site.
    · client-rendered cards (wishlist, finder pool, article rails) are inserted
      after load, so anything binding at load misses them. Delegation covers a
      card the moment it exists.

  The click is stopped from bubbling because the card around the button is
  usually an <a> to the product page: without that, adding to the cart also
  navigated away from the page you were shopping.

  Degrades honestly: with no fetch or no variant id the click is left alone, so
  it falls through to the card's own link instead of dying silently.
*/
(function () {
  if (window.__kiwiQuickAdd) return;
  window.__kiwiQuickAdd = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function btnFrom(node) {
    /* not Element.closest directly: the click usually lands on the <svg> or a
       <path> inside the button, and SVG elements only grew closest() later.
       .kh-padd is the LABELLED variant used by the article product block and
       rail; those buttons carry both classes. */
    while (node && node !== document) {
      if (node.classList && (node.classList.contains('pk-padd') || node.classList.contains('kh-padd'))) return node;
      node = node.parentNode;
    }
    return null;
  }

  /* Icon buttons have nothing to say — the opening drawer is the confirmation.
     A labelled button says it, because a failed add that looks like nothing
     happened just gets clicked again. */
  function labelled(b) {
    return !b.querySelector('svg') && !!(b.textContent || '').trim();
  }

  document.addEventListener('click', function (ev) {
    var b = btnFrom(ev.target);
    if (!b) return;

    var vid = +(b.dataset && b.dataset.vid);
    if (!vid || !window.fetch) return;   /* let the card's link take over */

    ev.preventDefault();
    ev.stopPropagation();
    if (b.disabled) return;
    b.disabled = true;

    var hasLabel = labelled(b);
    var original = hasLabel ? b.textContent : '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (c) {
        var cn = document.getElementById('cartn');
        if (cn && c && c.item_count != null) cn.textContent = c.item_count;
        if (window.gsap && !reduce) {
          window.gsap.fromTo(b, { scale: 0.86 }, { scale: 1, duration: 0.45, ease: 'back.out(2.5)' });
        }
        if (hasLabel) b.textContent = b.getAttribute('data-added') || 'Added';
        document.dispatchEvent(new CustomEvent('kiwi:cart-open'));
        setTimeout(function () {
          if (hasLabel) b.textContent = original;
          b.disabled = false;
        }, hasLabel ? 1400 : 900);
      })
      .catch(function () {
        if (hasLabel) {
          b.textContent = 'Try again';
          setTimeout(function () { b.textContent = original; b.disabled = false; }, 1400);
        } else {
          b.disabled = false;
        }
      });
  });
})();
